import { Form, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Endpoints from "../../api/endpoints";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import PageRoutes from "../../utils/routes";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import ApplicationForm from "./ApplicationForm";
import routes from "../../utils/routes";

const UpdateApplication = () => {
  const [form] = Form.useForm();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const params = useParams();
  const appId = params.appId;

  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const [initialValues, setInitialValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchApplicationDetails();
  }, []);

  const fetchApplicationDetails = async () => {
    setIsLoading(true);
    const httpParams = { id: appId };

    const result = await EndpointFunctions.fetchData({
      axiosPrivate: axiosPrivate,
      endpointURL: Endpoints.getApplication,
      httpParams: httpParams,
    });

    if (result.success) {
      setIsLoading(false);
      setInitialValues(result.data);
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const updateApplication = async (values) => {
    setIsLoading(true);
    console.log("---VALUES---", values);

    const requestBody = {
      id: appId,
      app: values.app,
      iosLink: values.iosLink,
      androidLink: values.androidLink,
    };
    console.log("---REQUEST BODY---", requestBody);

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.updateApplication,
      axiosPrivate: axiosPrivate,
      requestBody: requestBody,
    });

    if (result.success) {
      setIsLoading(false);
      showModal("Başarılı", "Uygulama Güncellendi.", () => {
        closeModal();
        navigate(routes.applications);
      });
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <>
      <div>
        <ApplicationForm
          form={form}
          onFinish={updateApplication}
          initialValues={initialValues}></ApplicationForm>
      </div>

      <Spin spinning={isLoading} fullscreen />

      <ModalComponent></ModalComponent>
    </>
  );
};

export default UpdateApplication;
